import styled, { css } from 'styled-components';
import { Icon } from '../Icon';
import { Grid } from '../Grid';

interface IStyledCardProps {
  isModal?: boolean;
  isCollapsed: boolean;
  isCollapsible: boolean;
  height: number;
  hideOverflow: boolean;
  hideBorder?: boolean;
}

const ICON_SIZE_SMALL = 16;
export const StyledCard = styled.div<IStyledCardProps>`
  background-color: ${(props) => props.theme.colors.defaultContentBackground};
  border: ${(props) => `1px solid ${props.theme.colors.defaultContentBorder}`};
  display: grid;
  gap: ${(props) => props.theme.spacing.spacing5};
  border-radius: ${(props) => props.theme.spacing.spacing4};
  position: ${(props) => (props.isModal ? `absolute` : `relative`)};
  ${(props) => (props.isModal ? `z-index:1;` : ``)};
  box-shadow: 0 ${(props) => props.theme.spacing.baseValue / 2} ${(props) => props.theme.spacing.baseUnit}
    ${(props) => props.theme.spacing.baseValue} ${(props) => props.theme.spacing.baseUnit} 0
    ${(props) => props.theme.colors.shadow};
  transition: height 0.3s ease-in;
  height: ${(props) => (props.height ? `${props.height}px` : 'auto')};
  ${(props) =>
    props.isCollapsed
      ? `height:${props.theme.spacing.roomyContentPaddingValue * 2 + props.theme.fonts.header2SizeValue * 1}${
          props.theme.spacing.baseUnit
        }`
      : ''}
  ${(props) => (props.hideOverflow ? `overflow:hidden` : '')}
`;
export const StyledCardContentWrapper = styled(Grid)<{ isCollapsible: boolean; contentPadding?: string }>`
  padding: ${(props) => (props.contentPadding ? props.contentPadding : props.theme.spacing.spacing5)};
  ${(props) =>
    props.isCollapsible &&
    css`
      padding-left: ${props.theme.spacing.defaultPaddingValue * 2 + ICON_SIZE_SMALL}px;
    `};
`;

interface IStyledCardCollapseProps {
  isCollapsed: boolean;
  onClick: () => void;
}

export const StyledCardCollapse = styled(Icon)<IStyledCardCollapseProps>`
  position: absolute;
  transition: transform 0.3s ease-in;
  transform: translate(
      ${(props) => (props.isCollapsed ? '75%' : '50%')},
      ${(props) => (props.isCollapsed ? '50%' : '75%')}
    )
    ${(props) => (props.isCollapsed ? 'rotate(-90deg)' : '')};
  top: ${(props) => props.theme.spacing.spacing5};
  left: ${(props) => props.theme.spacing.spacing1};
  color: ${(props) => props.theme.colors.black};
  cursor: pointer;
`;
